import React from 'react'
import "../style/AboutMe.css"
import AOS from "aos";

const AboutMe = () => {
    return (
        <div data-aos="fade-in" className='aboutme_container'>
            <h1>My Journey</h1>
            <p className='aboutme_text'>
                Hey there! I'm Tomer, and ever since I was a kid, I've been head over heels for video games.
                They've always had this magical way of transporting me to far-off worlds and feeding my curiosity.
                So, I decided to dedicate my life to creating games and learning everything I could about the process.
            </p>
            <p className='aboutme_text'>
                Now, here's a little secret: I actually began my coding journey as a front-end web developer.
                Strange, right? While I enjoyed it, I always felt this gravitational pull towards game development.
                So, I took the plunge and started learning Unity and C#.
            </p>
            <p className='aboutme_text'>
                As I started to bring my ideas to life, I quickly realized that creating games was a bit like
                trying to assemble a puzzle while riding a rollercoaster: thrilling, challenging, and sometimes
                a bit nauseating! I dove headfirst into the world of game design and human psychology, devouring
                books and learning everything I could to improve my craft.
            </p>
            <p className='aboutme_text'>
                Luckily, I stumbled upon a partner in crime along the way. Together, we embarked on a wild
                journey of game development, and we've managed to release a few titles on the Google Play Store.
            </p>
            <p className='aboutme_text'>
                So, here I am now – a bit older, a bit wiser, and still learning every day. My passion for
                gaming continues to fuel my creativity, and I'm excited to share my adventures with you. Feel
                free to poke around my portfolio, and let's bond over the joy that games bring to our lives!
            </p>
        </div>
    )
}

export default AboutMe
